import React from "react";

const HomePage: React.FC = () => {
  return <div className="flex flex-col min-h-screen"></div>;
};

export default HomePage;
